module.exports = __webpack_public_path__ + "img/down_btn.78b16b1d.svg";